import * as React from "react";

import { ChoiceModal } from "../../../components";

export interface ModalProps {
  handleClose: () => void;
  isOpen: boolean;
}

const PhoneInputModal = (props: ModalProps) => (
  <ChoiceModal
    {...props}
    bodyClassName="phone-input-modal"
    onConfirm={props.handleClose}
  >
    <h3 className="text-center">Cảm ơn!</h3>
    <p className="text-center">
      Chúng tôi đã nhận được yêu cầu hỗ trợ của quý khách. <br />
      Vui lòng để ý điện thoại, chúng tôi sẽ gọi trong ít phút nữa
    </p>
  </ChoiceModal>
);

export default PhoneInputModal;



// WEBPACK FOOTER //
// ./src/routes/Step1/components/PhoneInputModal.tsx